/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CampaignExecutionCustomer {
  campaignId?: number;
  createdAt?: Date;
  email?: string;
  executionCustomerId?: number;
  executionId?: number;
  freightValue?: number;
  giftValue?: number;
  personId?: number;
  resultMessage?: string;
  resultStatus?: string;
  shipmentType?: string;
  shippingOrderId?: string;
  subscriptionTypeId?: number;
  subscriptionValue?: number;
}
